/**
 * 
 * @file Open With button when multiple integrations are present
 * @author Box
 */

import * as React from 'react';
import MenuToggle from 'box-react-ui/lib/components/dropdown-menu/MenuToggle';
import IconOpenWith from 'box-react-ui/lib/icons/general/IconOpenWith';
import Button from 'box-react-ui/lib/components/button/Button';
import { FormattedMessage } from 'react-intl';
import OpenWithButtonContents from './OpenWithButtonContents';
import Tooltip from '../Tooltip';
import { CLASS_INTEGRATION_ICON } from '../../constants';
import messages from '../messages';

var MultipleIntegrationsOpenWithButton = function MultipleIntegrationsOpenWithButton(buttonProps) {
    return React.createElement(
        Tooltip,
        {
            text: React.createElement(FormattedMessage, messages.defaultOpenWithDescription),
            position: 'middle-left'
        },
        React.createElement(
            Button,
            buttonProps,
            React.createElement(
                MenuToggle,
                null,
                React.createElement(
                    OpenWithButtonContents,
                    null,
                    React.createElement(IconOpenWith, {
                        height: 26,
                        width: 26,
                        className: CLASS_INTEGRATION_ICON
                    })
                )
            )
        )
    );
};

export default MultipleIntegrationsOpenWithButton;